export default {"src":"/_next/static/media/steps-sp.6c6b81d0.svg","height":400,"width":547};